import React from "react";

type AdminVerifySectionProps = {
  adminDocumentTypes: Record<string, string>;
  selectedDocTypes: string[];
  onToggle: (key: string) => void;
  onClear: () => void;
  onSave: () => void;
};

const AdminVerifySection: React.FC<AdminVerifySectionProps> = ({
  adminDocumentTypes,
  selectedDocTypes,
  onToggle,
  onClear,
  onSave,
}) => {
  return (
    <div className="margin-top-4u">
      <h3 className="h3">For Admin use only</h3>
      <p className="p3 -book">
        Administrators can verify and confirm document types in the <b>Admin section</b> below.
      </p>
      <ul className="list-disc ml-5!">
        <li className="p3 -book">Review the listed document types and check the appropriate boxes.</li>
        <li className="p3 -book">Click <b>Save</b> to confirm your review.</li>
      </ul>

      <h4 className="h4 margin-top-2u">Document Type</h4>
      <div className="mt-2 flex flex-col gap-2 ml-1">
        {Object.entries(adminDocumentTypes).map(([key, label]) => (
          <div key={key} className="flex items-start">
            <input
              type="checkbox"
              aria-label={typeof label === "string" ? label : String(label)}
              className="cursor-pointer scale-75"
              checked={selectedDocTypes.includes(key)}
              onChange={() => onToggle(key)}
            />
            <span className="p3 -book leading-tight ml-8! mt-2.5! cursor-default select-none">{label}</span>
          </div>
        ))}
      </div>

      {/* Admin actions */}
      <div className="flex flex-col gap-4 margin-top-2u sm:flex-row">
        <button className="button -secondary" onClick={onClear}>
          Clear information
        </button>
        <button className="button -primary -light" onClick={onSave}>
          Save
        </button>
      </div>
    </div>
  );
};

export default AdminVerifySection;
